/**
 * 布局相关常量配置
 */
export const LAYOUT = {
  HEADER: {
    PADDING: "0 24px",
    BORDER_COLOR: "#272727",
  },
  CONTENT: {
    PADDING: "24px",
  },
} as const;

/**
 * 模态框相关常量配置
 */
export const MODAL = {
  WIDTH: {
    LARGE: "60%",
  },
  TEXT_AREA: {
    MIN_ROWS: 5,
    MAX_ROWS: 20,
  },
} as const; 